import { alpha } from '@mui/material';
export const usePersonProfileStyles = () => {
    return {
        container: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: (theme) => '#F4FBFF',
            borderRadius: (theme) => theme.spacing(3),
            border: `1px solid ${(theme) => alpha(theme.palette.grey[500], 0.24)}`,
            overflow: 'hidden'
        },
        profileBackground: {
            position: 'relative',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            paddingBottom: (theme) => theme.spacing(2)
        },
        avatarContainer: {
            position: 'relative',
            zIndex: 2,
            marginBottom: (theme) => theme.spacing(2)
        },
        avatar: {
            width: 80,
            height: 80,
            fontSize: '28px',
            fontWeight: 700,
            backgroundColor: (theme) => theme.palette.grey[100],
            color: (theme) => theme.palette.primary.main
        },
        profileContent: {
            // gap: (theme: Theme) => theme.spacing(0.5),
            // marginTop:(theme: Theme) => theme.spacing(3),
            // marginBottom:(theme: Theme) => theme.spacing(1),
            textAlign: 'center'
        },
        chipContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: (theme) => theme.spacing(0.5),
            marginTop: (theme) => theme.spacing(5),
            marginBottom: (theme) => theme.spacing(1)
        },
        designationChip: {
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.primary.main,
            fontSize: '12px',
            fontWeight: 600,
            textTransform: 'uppercase',
            padding: (theme) => theme.spacing(0.5, 1.5),
            borderRadius: (theme) => theme.spacing(1)
        },
        name: {
            marginBottom: (theme) => theme.spacing(0.5)
        },
        contactIcons: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: (theme) => theme.spacing(2)
        },
        contactIcon: {
            border: 'none'
        },
        separator: {
            height: '1px',
            backgroundColor: (theme) => theme.palette.grey[200],
            margin: (theme) => theme.spacing(0, 3, 2, 3)
        },
        infoSection: {
            display: 'grid',
            gridTemplateColumns: {
                xs: 'repeat(2, minmax(0, 1fr))',
                sm: 'repeat(3, minmax(0, 1fr))',
                md: 'repeat(6, minmax(0, 1fr))'
            },
            columnGap: (theme) => theme.spacing(1.5),
            rowGap: (theme) => theme.spacing(2),
            alignItems: 'start',
            padding: (theme) => theme.spacing(2, 2, 2, 2)
        },
        infoItem: {
            position: 'relative',
            textAlign: 'center',
            minWidth: 0,
            px: 2,
            '&::after': {
                content: '""',
                position: 'absolute',
                top: 4,
                bottom: 4,
                right: 0,
                width: '1px',
                backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.24),
                display: { xs: 'none', md: 'block' }
            }
        },
        infoItemNoDivider: {
            '&::after': {
                display: 'none'
            }
        },
        infoValue: {
            fontSize: '16px',
            fontWeight: 700,
            color: (theme) => theme.palette.grey[900]
        }
    };
};
